import React, { useState, useEffect } from 'react';
import { Lock, AlertTriangle } from 'lucide-react';

const MaintenanceMode = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Mot de passe de maintenance (à stocker dans les variables d'environnement en production)
  const MAINTENANCE_PASSWORD = 'admin123';
  const MAINTENANCE_ENABLED = 'true';

  useEffect(() => {
    // Vérifier si le mode maintenance est activé
    setIsMaintenanceMode(MAINTENANCE_ENABLED);

    // Vérifier si l'utilisateur est déjà authentifié (via sessionStorage)
    const authenticated = sessionStorage.getItem('maintenance_authenticated') === 'true';
    setIsAuthenticated(authenticated);
  }, [MAINTENANCE_ENABLED]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (password === MAINTENANCE_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('maintenance_authenticated', 'true');
      setPassword('');
    } else {
      setError('Mot de passe incorrect');
      setPassword('');
    }
  };

  // Si le mode maintenance n'est pas activé ou si l'utilisateur est authentifié, afficher l'application
  if (!isMaintenanceMode || isAuthenticated) {
    return <>{children}</>;
  }

  // Afficher la page de maintenance
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Carte de maintenance */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl border border-white/20 p-8">
          {/* Icône et titre */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-yellow-500/20 rounded-full mb-4">
              <AlertTriangle className="w-10 h-10 text-yellow-400" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">
              Mode Maintenance
            </h1>
            <p className="text-gray-300">
              Le site est actuellement en maintenance. Veuillez entrer le mot de passe pour accéder.
            </p>
          </div>

          {/* Formulaire de mot de passe */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
                Mot de passe
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-white/20 rounded-lg bg-white/5 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="Entrez le mot de passe"
                  required
                />
              </div>
              {error && (
                <p className="mt-2 text-sm text-red-400 flex items-center">
                  <AlertTriangle className="w-4 h-4 mr-1" />
                  {error}
                </p>
              )}
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-3 px-4 rounded-lg hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 transition-all transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Accéder au site
            </button>
          </form>

          {/* Informations supplémentaires */}
          <div className="mt-6 pt-6 border-t border-white/10">
            <p className="text-sm text-gray-400 text-center">
              Nous effectuons des mises à jour pour améliorer votre expérience.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} MAPATA Cloud. Tous droits réservés.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
